import {RepositoryFactory} from '@/app/repositories/repository-factory.js';
import Repository from '@/app/repositories/repository'

const orderRepository = RepositoryFactory.get('order');

export default Object.assign(orderRepository, {
    addOrder : function(items){
        return Repository.post(`/order/createOrder`, items);
    },
    getOrdersByUser: function(userId){
        return Repository.get(`/order/getOrdersByUserId?userId=`+userId);
    },
    getOrderDetails: function(orderId){
        return Repository.get(`/order/getOrderDetails?orderId=`+orderId);
    },
    updateOrderTitle: function(orderId, title){
        var data = {
            id: orderId,    
            UserDefinedTitle: title
        };
        return Repository.post(`/order/updateOrderTitle`, data);
    }
});
